import KoioteButtonFeedback from "./KoioteButtonFeedback.vue";
import KoioteButtonFeedbackProperties from "./KoioteButtonFeedbackProperties.vue";
import KoioteButtonFeedback1Property from "./default.json";

export default {
  install(Vue) {
    Vue.component(KoioteButtonFeedback.name, KoioteButtonFeedback);
    Vue.component(KoioteButtonFeedbackProperties.name, KoioteButtonFeedbackProperties);
    Vue.prototype.$ValueLabelProperties = KoioteButtonFeedback1Property;
  },
};
